module.exports = __webpack_public_path__ + "static/img/purple.a8ecc6f9.png";